export default "__VITE_ASSET__B2CwfyT$__"